import { getApiUrl } from './api';

/**
 * Chat API - Frontend API client for chat backend
 * Handles all communication with the Go backend
 */

const CHAT_BASE_URL = '/api/v1/chat';

/**
 * Initialize a new chat session
 */
export const initChat = async (businessId, locationId, menuId, userId = null, sessionId = null) => {
  try {
    const response = await fetch(getApiUrl(`${CHAT_BASE_URL}/init`), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        businessId: businessId,
        locationId: locationId,
        menuId: menuId,
        userId: userId || 0,
        sessionId: sessionId
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to initialize chat:', error);
    throw error;
  }
};

/**
 * Send a message to the chat
 */
export const sendMessage = async (sessionId, message) => {
  console.log("send message with", sessionId, message)
  try {
    const response = await fetch(getApiUrl(`${CHAT_BASE_URL}/message`), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        sessionId: sessionId,
        message: message,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to send message:', error);
    throw error;
  }
};

/**
 * Validate a cart item before adding
 */
export const validateCart = async (sessionId, product) => {
  try {
    const response = await fetch(getApiUrl(`${CHAT_BASE_URL}/validate`), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        session_id: sessionId,
        product: product,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to validate cart:', error);
    throw error;
  }
};

/**
 * Chat API object with all methods
 */
export const chatApi = {
  init: initChat,
  sendMessage,
  validateCart,
};

/**
 * Convenience method that wraps init with parameters from context
 */
chatApi.init = async ({ businessId, locationId, menuId, userId, sessionId }) => {
  return initChat(businessId, locationId, menuId, userId, sessionId);
};
